module.exports = __webpack_public_path__ + "img/1280x720-Dusk.045964bb.jpg";